// Import model
import { DataviewOtgCatalogManufacturerResponse } from '../models/DataviewOtgCatalogManufacturerResponse';

// Import base class serializer

// Import dependency types (models and enums used in properties)
import { DataView } from '../models/DataView';
import { FilterOtgCatalogManufacturerRequest } from '../models/FilterOtgCatalogManufacturerRequest';
import { OtgCatalogManufacturer } from '../models/OtgCatalogManufacturer';

// Import dependency serializers (for complex types)
import { DataViewSerializer } from './DataViewSerializer';
import { FilterOtgCatalogManufacturerRequestSerializer } from './FilterOtgCatalogManufacturerRequestSerializer';
import { OtgCatalogManufacturerSerializer } from './OtgCatalogManufacturerSerializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for DataviewOtgCatalogManufacturerResponse - handles JSON serialization and deserialization with type validation
 */
export class DataviewOtgCatalogManufacturerResponseSerializer {
  /**
   * Deserializes a JSON string into a DataviewOtgCatalogManufacturerResponse instance
   */
  static deserialize(json: string): DataviewOtgCatalogManufacturerResponse {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a DataviewOtgCatalogManufacturerResponse instance
   */
  static fromObject(obj: any): DataviewOtgCatalogManufacturerResponse {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to DataviewOtgCatalogManufacturerResponse');
    }


    const instance: DataviewOtgCatalogManufacturerResponse = {
      result: obj['Result'] ? (obj['Result'] as any[]).map((item: any) =>
        OtgCatalogManufacturerSerializer.fromObject(item)
      ) : [] as any,
      request: obj['Request'] ? FilterOtgCatalogManufacturerRequestSerializer.fromObject(obj['Request']) : undefined as any,
      dataView: obj['DataView'] ? DataViewSerializer.fromObject(obj['DataView']) : undefined as any,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of DataviewOtgCatalogManufacturerResponse instances
   */
  static deserializeArray(json: string): DataviewOtgCatalogManufacturerResponse[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a DataviewOtgCatalogManufacturerResponse instance to a JSON string
   */
  static serialize(instance: DataviewOtgCatalogManufacturerResponse): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a DataviewOtgCatalogManufacturerResponse instance to a plain object
   */
  static toObject(instance: DataviewOtgCatalogManufacturerResponse): any {
    return {
      'Result': instance.result?.map((item: any) =>
        OtgCatalogManufacturerSerializer.toObject(item)
      ),
      'Request': instance.request ? FilterOtgCatalogManufacturerRequestSerializer.toObject(instance.request) : undefined,
      'DataView': instance.dataView ? DataViewSerializer.toObject(instance.dataView) : undefined,
    };
  }

  /**
   * Serializes an array of DataviewOtgCatalogManufacturerResponse instances to a JSON string
   */
  static serializeArray(instances: DataviewOtgCatalogManufacturerResponse[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
